<div class="factory-container">
  <div class="text-center img-container">
    <img (click)="editImage()" class="factory-image cursor" src="{{newImage ? newImage : factoryData?.logo}}" (error)="onImgError($event)" i18n-alt="@@companyLogo" alt="Company logo">
    <mat-icon fontSet="material-icons-round" (click)="editImage()" color="accent" class="cursor edit-icon" i18n-aria-label="@@editImage" aria-label="Edit Image">edit</mat-icon>
  </div>
  <form [formGroup]="factoryForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@companyNameLabel">Company name</mat-label>
        <input data-testid="factory_name" matInput id="company_name" placeholder="Company name" i18n-placeholder="@@companyNamePlaceholder" name="company_name" formControlName="company_name" required/>
        <mat-error>
          @if (!factoryForm.get('company_name').valid && factoryForm.get('company_name').touched) {
            @if (factoryForm.get('company_name').errors && factoryForm.get('company_name').errors['required'] || factoryForm.get('company_name').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@companyHistoryLabel">Company history</mat-label>
        <textarea data-testid="factory_history" matInput id="company_history" placeholder="Company history" i18n-placeholder="@@companyHistoryPlaceholder" name="company_history" formControlName="company_history" required></textarea>
        <mat-error>
          @if (!factoryForm.get('company_history').valid && factoryForm.get('company_history').touched) {
            @if (factoryForm.get('company_history').errors && factoryForm.get('company_history').errors['required'] || factoryForm.get('company_history').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@companyMissionLabel">Company mission</mat-label>
        <textarea data-testid="company_mission" matInput id="company_mission" placeholder="Company mission" i18n-placeholder="@@companyMissionPlaceholder" name="company_mission" formControlName="company_mission" required></textarea>
        <mat-error>
          @if (!factoryForm.get('company_mission').valid && factoryForm.get('company_mission').touched) {
            @if (factoryForm.get('company_mission').errors && factoryForm.get('company_mission').errors['required'] || factoryForm.get('company_mission').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@companyVisionLabel">Company vision</mat-label>
        <textarea data-testid="company_vision" matInput id="company_vision" i18n-placeholder="@@companyVisionPlaceholder" placeholder="Company vision" name="company_vision" formControlName="company_vision" required></textarea>
        <mat-error>
          @if (!factoryForm.get('company_vision').valid && factoryForm.get('company_vision').touched) {
            @if (factoryForm.get('company_vision').errors && factoryForm.get('company_vision').errors['required'] || factoryForm.get('company_vision').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div class="factory-button">
      <button i18n="@@saveChanges" data-testid="factory_save_button" mat-raised-button color="primary" (click)="onSubmit()">Save Changes</button>
    </div>
  </form>
</div>
